import {
  fetchConcerns,
  fetchConversationList,
  PostConcernConversation,
  createSupportTicket
} from "../../api/concernsListApi";
import * as Endpoints from "../../entities/Endpoints";

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const fetchConcernsThunk = createAsyncThunk(
Endpoints.FETCH_CONCERNS_LIST,
async (coachId, { rejectWithValue }) => {
  try {
    const data = await fetchConcerns(coachId);
    return data;
  } catch (error) {
    return rejectWithValue(error.message);
  }
}
);

export const fetchConversationThunk = createAsyncThunk(
  Endpoints.FETCH_CONCERNS_CONVERSATION_LIST,
  async (coachId, { rejectWithValue }) => {
    try {
      const data = await fetchConversationList(coachId);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const postConcernConversationThunk = createAsyncThunk(
  Endpoints.POST_CONCERNS_CONVERSATION,
  async (message, { rejectWithValue }) => {
    try {
      const data = await PostConcernConversation(message);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const createSupportTicketThunk = createAsyncThunk(
  Endpoints.CREATE_SUPPORT_TICKET,
  async (formData, { rejectWithValue }) => {
    try {
      const data = await createSupportTicket(formData);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



const concernsListSlice = createSlice({
name: "getConcerns",
initialState: {
  concernsList: null,
  conversationList:null,
  isloading: false,
  isLoadingConversation:false,
  successMessage: null,
  updateSuccessMessage: "",
  updateFailedMessage: "",
},
reducers: {
  clearUpdateMessage: (state) => {
    state.updateSuccessMessage = "";
    state.updateFailedMessage = "";
  },
},

extraReducers: (builder) => {
  builder
    .addCase(fetchConcernsThunk.pending, (state) => {
      state.isloading = true;
      state.error = null;
      state.updateSuccessMessage = "";
      state.updateFailedMessage = "";
    })
    .addCase(fetchConcernsThunk.fulfilled, (state, action) => {
      state.isloading = false;
      state.concernsList = action.payload;
    })
    .addCase(fetchConcernsThunk.rejected, (state, action) => {
      state.isloading = false;
      state.error = action.payload;
      state.concernsList = action.payload;
      
    })

    .addCase(fetchConversationThunk.pending, (state) => {
      state.isLoadingConversation = true;
      state.error = null;
      state.updateSuccessMessage = "";
      state.updateFailedMessage = "";
    })
    .addCase(fetchConversationThunk.fulfilled, (state, action) => {
      state.isLoadingConversation = false;
      state.conversationList = action.payload;
    })
    .addCase(fetchConversationThunk.rejected, (state, action) => {
      state.isLoadingConversation = false;
      state.error = action.payload;
      state.conversationList = null;
    })



    .addCase(postConcernConversationThunk.pending, (state) => {
      state.isloading = true;
      state.error = null;
      state.updateSuccessMessage = "";
      state.updateFailedMessage = "";
    })
    .addCase(postConcernConversationThunk.fulfilled, (state, action) => {
      state.isloading = false;
      state.successMessage = action.payload.message;
    })
    .addCase(postConcernConversationThunk.rejected, (state, action) => {
      state.isloading = false;
      state.error = action.payload;
      state.updateFailedMessage = action.payload.message;
    })


    .addCase(createSupportTicketThunk.pending, (state) => {
      state.isloading = true;
      state.error = null;
      state.updateSuccessMessage = "";
      state.updateFailedMessage = "";
    })
    .addCase(createSupportTicketThunk.fulfilled, (state, action) => {
   
      state.isloading = false;
      state.updateSuccessMessage = action.payload?.message || "Ticket created successfully";
      state.updateFailedMessage = "";
    })
    .addCase(createSupportTicketThunk.rejected, (state, action) => {
    
      state.isloading = false;
      state.error = action.payload;
      state.updateFailedMessage = action.payload?.message || "Failed to create ticket";
      state.updateSuccessMessage = "";
    })
    


},
});
export const { clearUpdateMessage } = concernsListSlice.actions;
export const concernsListReducer = concernsListSlice.reducer;
